import React, { forwardRef } from "react";
import { Select } from "antd";
import handleTabIndex from "../../Utils/HandleTabIndex";

const SelectBasico = forwardRef(({ dados, getItem, ...rest }, ref) => {

  const keyPress = e => {
    if (e.keyCode === 13) {
      handleTabIndex(rest.tabIndex, rest.nextTab);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return <>
    <div onMouseDown={e => e.preventDefault()}>
      <Select
        showSearch
        onKeyDown={keyPress}
        data-cy={rest.dataCy}
        allowClear={rest.allowClear}
        {...rest}
        style={{ width: "100%", ...rest.style }}
        optionFilterProp="children"
        onClick={e => e.target.focus()}
        filterOption={(input, option) => {
          if (!option.children) return false;
          return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
        tabIndex={rest?.tabIndex}
        dropdownStyle={{ zIndex: rest.zIndex }}
        ref={ref}
      >
        {rest.multiNivel ? (<>
          {dados?.map(pai => (
            <Select.OptGroup key={pai.id} label={pai.nome}>
              {pai.filhos?.map((item) => (
                <Select.Option title={getItem ? getItem(item) : item.nome} key={item.id} value={item.id}>
                  {getItem ? getItem(item) : item.nome}
                </Select.Option>
              ))}
            </Select.OptGroup>
          ))}
        </>)
          :
          <>
            {dados?.map((item, inx) => <Select.Option title={getItem ? getItem(item) : item.nome} key={item.id} value={item.id} data-cy={rest.dataCy + "-item-" + inx}>
              {getItem ? getItem(item) : item.sigla ? `${item.sigla} | ${item.nome}` : item.nome}
            </Select.Option>
            )}
          </>
        }
      </Select>
    </div>
  </>;
});

export default SelectBasico;
